import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import FlightTakeoffIcon from '@material-ui/icons/FlightTakeoff';
import { MOVE_OVERVIEW_PATH } from './model';
import { moveRootRouteRef } from './routes';

const moveOverviewPage = PageBlueprint.make({
  params: {
    path: MOVE_OVERVIEW_PATH,
    title: 'MOVE',
    icon: <FlightTakeoffIcon fontSize="inherit" />,
    routeRef: moveRootRouteRef,
    loader: () =>
      import('./MoveOverviewPage').then(m => <m.MoveOverviewPage />),
  },
});

export const horizonMovePlugin = createFrontendPlugin({
  pluginId: 'horizon-move',
  title: 'MOVE',
  routes: {
    root: moveRootRouteRef,
  },
  extensions: [
    moveOverviewPage,
    PageBlueprint.make({
      name: 'execution',
      params: {
        path: '/move/executions',
        title: 'MOVE operator workspace',
        loader: () =>
          import('./MoveExecutionPage').then(m => <m.MoveExecutionPage />),
      },
    }),
    PageBlueprint.make({
      name: 'evidence-review',
      params: {
        path: '/move/reviews',
        title: 'Independent MOVE evidence review',
        loader: () =>
          import('./MoveEvidenceReviewPage').then(m => (
            <m.MoveEvidenceReviewPage />
          )),
      },
    }),
  ],
});
